export default "__VITE_ASSET__q1sAHSOe__"